module.exports = __webpack_public_path__ + "img/pro_two_5.66ac765d.jpg";